<template lang="html">
  <div class="inner-modal lcbcft">
  	<div class="head-modal row">
  		<div class="title column">
  			<div class="head-modal-title">
  				Questionnaire
  			</div>
				<div class="head-modal-emphase">
					Vérification de la cohérence des informations du Paysage Patrimonial
				</div>
  		</div>
  	</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="ctn-field">
					<div class="label">
						Date de signature du questionnaire client
					</div>
					<div class="ctn-date-input">
						<input-date v-model="date" v-validate="'required'" name="date" />
					</div>
				</div>
				<div class="ctn-field">
					<div class="label">
						Cohérence des informations
					</div>
					<custom-toggle v-model="consistency" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Complétude des données
					</div>
					<custom-toggle v-model="completeness" />
				</div>
				<div class="ctn-field">
					<div class="label">
						Avertissement envoyé au client
					</div>
					<custom-toggle v-model="warningSent" />
				</div>

				<!-- <div class="error-message" v-if="errorInForm">Une erreur est présente dans le formulaire</div> -->
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="sendForm">Valider</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import inputDate from '@/common/components/Form/InputDate'
import CustomToggle from '@/common/components/Form/CustomToggle'
import emma from '../../common/services/Emma'
import { mapGetters } from 'vuex'

export default {
	name: 'PatrimonialConsistency',
	components: {
		inputDate,
		CustomSelect,
		CustomToggle
	},
	data () {
		return {
			date: new Date(),
			consistency: false,
			completeness: false,
			warningSent: false,
			errorInForm: false,
			errorMessage: ''
		}
	},
	mounted () {
		console.log("modal estate", this.estate)
		this.completeness = this.estate.advisorCheck.advisorCompletenessCheck
		this.consistency = this.estate.advisorCheck.advisorConsistencyCheck
		this.warningSent = this.estate.advisorCheck.advisorWarningSentToClient
	},
	methods: {
		close () {
			this.$emit('close')
		},
		sendForm () {
			this.errorInForm = false
			emma.post('api/estate/private/doc/sendmailcheckpaysage', {
				user_id: this.$router.currentRoute.params.clientId,
				date: this.date,
				consistency: this.consistency,
				completeness: this.completeness,
				warningSent: this.warningSent
			}).then((result) => {
				this.$emit('close')
			}).catch((error) => {
				console.error('Erreur lors de l\'envoi:', error)
				console.error('Détails de l\'erreur:', {
					message: error.message,
					response: error.response
				})
				this.errorInForm = true
			})
		}
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		}),
	}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PatrimonialConsistency.vue?36d3dfaa